<template>
    <div class="bg-surface-0 dark:bg-surface-950 p-20">
        <div class="flex flex-col gap-10 items-center justify-center">
            <div
                class="w-full flex justify-center items-center bg-[radial-gradient(50%_109137.91%_at_50%_50%,color-mix(in_srgb,_var(--p-primary-500)_10%,transparent)_0%,rgba(254,244,247,0)_100%)] rounded-lg"
            >
                <div class="bg-surface-0 dark:bg-surface-950 px-8">
                    <div
                        class="bg-primary-50 dark:bg-primary-900 text-primary dark:text-primary-100 rounded-xl px-2 py-1 font-medium"
                    >
                        404
                    </div>
                </div>
            </div>
            <div class="flex flex-col items-center gap-4">
                <h1 class="text-5xl font-bold text-surface-900 dark:text-surface-0 text-center leading-tight">
                    Testimonial Not Found
                </h1>
                <p class="text-lg text-surface-500 dark:text-surface-400 text-center mt-0 leading-normal">
                    Sorry, the video you are looking for is not available.
                </p>
            </div>
        </div>
    </div>
</template>
<script setup></script>
